import { LenderName, LoanCriteria, OrderCriteria } from '@nemuru-eng/js-api-client';

import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { Text } from '@/components/shared/components/Text';

export const lenderLogoFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.18,
    field: 'lenderName',
    sortable: false,
    align: 'center',
    headerName: <Text tId={'SELECTED_LENDER'} />,
    renderCell: (rowData: { row: OrderCriteria | LoanCriteria }) => (
      <div style={{ display: 'flex' }} className={'overflow-text-ellipsis'}>
        {rowData.row.loanApplicationSelected?.lenderName ? (
          LenderIcon({ lenderName: rowData.row.loanApplicationSelected?.lenderName as LenderName })
        ) : (
          <>-</>
        )}
      </div>
    ),
  };
};
